import React, { useState, useEffect } from 'react'
import { useCookies } from 'react-cookie'
import { useTranslation } from 'react-i18next'

const STORAGE_KEY = 'lexmed_cookie_consent'
const COOKIE_NAME = 'cookie_consent'
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365 // 365 days in seconds

const CookieConsentBanner = () => {
  const { t } = useTranslation('common')
  const [, setCookie] = useCookies([COOKIE_NAME])
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    // Show banner only if no preference has been recorded yet
    const stored = localStorage.getItem(STORAGE_KEY)
    if (!stored) {
      setVisible(true)
    }
  }, [])

  const handleAccept = () => {
    const timestamp = new Date().toISOString()
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ accepted: true, timestamp })
    )
    setCookie(COOKIE_NAME, 'accepted', { path: '/', maxAge: COOKIE_MAX_AGE })
    setVisible(false)
  }

  const handleDecline = () => {
    const timestamp = new Date().toISOString()
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ accepted: false, timestamp })
    )
    setCookie(COOKIE_NAME, 'declined', { path: '/', maxAge: COOKIE_MAX_AGE })
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 bg-gray-900 text-white px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-4 shadow-lg"
      role="dialog"
      aria-label="Cookie consent"
    >
      <p className="text-sm text-gray-200 flex-1">
        {t('cookieConsent.message')}
      </p>
      <div className="flex gap-3 shrink-0">
        <button
          onClick={handleDecline}
          className="px-4 py-2 text-sm font-medium bg-gray-600 text-white rounded-lg hover:bg-gray-500 transition-colors"
        >
          {t('cookieConsent.decline')}
        </button>
        <button
          onClick={handleAccept}
          className="px-4 py-2 text-sm font-medium bg-blue-600 text-white rounded-lg hover:bg-blue-500 transition-colors"
        >
          {t('cookieConsent.accept')}
        </button>
      </div>
    </div>
  )
}

export default CookieConsentBanner
